<template>
  <v-col sm="12" class="overrideCol" id="mapid">
    <div class="mapWrapper" ref="leafletWrapper">
      <v-card
        style="position: fixed; left: 50px; top: 59px; z-index: 5"
        elevation="2"
        height="30"
        class="rounded_card"
      >
        <v-card-text>
          <v-switch
            color="primary"
            v-model="showLabels"
            :label="!showLabels ? labels.showLabels : labels.hideLabels"
          ></v-switch>
          <v-btn @click="setCurrentLocation">Trenutna lokacija</v-btn>
        </v-card-text>
      </v-card>
      <l-map
        ref="map"
        :zoom="zoom"
        :max-zoom="maxZoom"
        :center="center"
        :options="mapOptions"
        style="height: 100%"
        class="ml-2"
      >
        <l-control-layers position="topright"></l-control-layers>
        <l-tile-layer
          v-for="tile in tileProviders"
          :key="tile.name"
          :visible="tile.visible"
          :url="tile.url"
          :name="tile.name"
          :attribution="tile.attribution"
          layer-type="base"
        />
        <template v-for="(marker, index) in locationMarkers">
          <l-marker
            :key="index + 'l'" 
            :draggable="true" 
            @dragend="moveMarker(marker, $event)" 
            :lat-lng="marker.latLng"
            @click="clickOnLocation(marker)"
            @mouseover="openPopup"
            @mouseleave="closePopup"
            >
            <l-popup>
              <div v-html="marker.name"></div>
            </l-popup>
          </l-marker>
      </template>
      </l-map>

      <template>
        <v-dialog
          v-model="dialog.show"
          @keydown.esc="onCloseDialogHandler"
          max-width="380"
        >
          <template v-if="dialog.show">
            <v-card flat tile>
              <BaseDialogTitle @close="onCloseDialogHandler">
                <template v-slot:title>Poi</template>
              </BaseDialogTitle>
              <v-card-text>
                <MapCrudComponent
                  mapType="leaflet"
                  :mapData="mapCrudData"
                  @closeMapCrudComponent="handleMapCrudComponentClose"
                  :submited="dialog.submited"
                  :closed="!dialog.show"
                  @resetSubmit="dialog.submited = false"
                ></MapCrudComponent>
              </v-card-text>
              <v-card-actions>
                <SubmitGroup
                  @close="onCloseDialogHandler"
                  :closeOnSubmit="closeOnSubmit"
                  @submit="onSubmitDialogHandler"
                />
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </template>

      <MapLocationCrudComponent
          :locationData="mapCrudLocationData"
          :dialog='locationDialog'
          @close="onCloseLocationDialogHandler"
      >
      </MapLocationCrudComponent>

    </div>
  </v-col>
</template>

<script>
import options from '../../../resource/maps/leafletOptions'
import BaseLeafletMapComponent from '../BaseLeafletMapComponent'
import { remove } from '../../../api/map.api'
import { latLng } from 'leaflet'
import httpClient from '../../../api/httpClient'
import translate from '@/utils/genTable/multilanguageHelper.js'
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LControl,
  LControlLayers,
  LPolyline
} from 'vue2-leaflet'
import LDraw from 'leaflet-draw'
import { mapState } from 'vuex'
import store from '@/store/store'
import Vue from 'vue'
import EventBus from '../../../event-bus'
import { globalConstants, poiTypes } from '@/utils/globalConstants'

export default {
  name: 'LeafletLocationComponent',
  extends: BaseLeafletMapComponent,
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LDraw,
    LControlLayers,
    LControl,
    LPolyline,
    LPolygon: () => import('vue2-leaflet'),
    LCircle: () => import('vue2-leaflet'),
    RouteHistoryResult: () =>
      import('@/components/map/route/RouteHistoryResult'),
    MapLocationCrudComponent: () =>
      import('@/components/map/MapLocationCrudComponent')
  },
  data() {
    return {
      zoom: null,
      maxZoom: null,
      center: null,
      tileProviders: [],
      mapOptions: {
        zoomSnap: null
      },
      poiData: {},
      labels: {
        showLabels: translate('Show Poi labels', 'maps'),
        hideLabels: translate('Hide Poi labels', 'maps')
      },
      locationDialog: {
        show: false
      },
      mapCrudLocationData: {},
      locationMarkers: [],
      readyToDeleteLocation: false,
      readyToEditLocation: false,
      coordinates: []
    }
  },
  created() {
    let { zoom, maxZoom, zoomSnap, center, tileProviders } = options
    this.zoom = zoom
    this.maxZoom = maxZoom
    this.center = latLng(center.lat, center.lng)
    this.tileProviders = tileProviders
    this.mapOptions.zoomSnap = zoomSnap
  },
  async mounted() {
    this.setupPoiControls(false)
    var that = this

    var url = '/pois'
    if (this.isUserDriverRole) {
      let pos = poiTypes.find(x => x.Name == "Pos");
      if (pos) {
        url += `?poiType=${pos.Id}`;
      }
    }
    var pois = await httpClient.get(url)
    store.dispatch('map/clearPois')
    pois.data.forEach(poi => {
      store.dispatch('map/addPoi', poi)
      poi.coordinates.forEach(c =>
        that.coordinates.push({
          longitude: c.longitude,
          latitude: c.latitude
        })
      )
    })

    var locations = await httpClient.get('/locations')
    locations.data.forEach(i => {
      let loc = {
        name: i.name,
        latLng: {
          lat: i.latitude,
          lng: i.longitude
        },
        id: i.id
      }
      that.coordinates.push({ longitude: i.longitude, latitude: i.latitude })
      that.locationMarkers.push(loc)
      store.dispatch('map/addLocation', loc)
    })

    setTimeout(() => {
      this.zoomToRoute(that.coordinates)
    }, 300)

    EventBus.$on('POI_NAME_IN_TABLE_EVENT', this.handlePoiNameInTableEvent)
    EventBus.$on('EDIT_POI_BUTTON_EVENT', this.handleEditPoiButtonEvent)
  },
  computed: {
    ...mapState('map', ['routes', 'locations']),
    ...mapState('user', ['isUserDriverRole']),
    locationsForDelete() {
      return this.locations.filter(
        x => !this.locationMarkers.some(y => y.id == x.id)
      )
    }
  },
  methods: {
    setCurrentLocation() {
      var that = this
      
      // navigator.geolocation.getCurrentPosition(function(position) {
      //   var latLong = latLng(position.coords.latitude, position.coords.longitude)
      //   console.log(latLong)
      //   that.center = latLong
      //   that.zoom = 20
      // }, function() {
      //     alert("Došlo je do greške, pokušajte ponovo.")
      // }, {
      //   enableHighAccuracy: true,
      //   maximumAge: 10000,
      //   timeout: 5000,
      // });
      this.$refs.map.mapObject.locate({ setView: true })
    },
    async setupPoiControls(hideControls) {
      /**
       * This is a recommended way to grab reference to leaflet map.
       * It is always available under $refs.map.
       */
      var that = this
      const map = this.$refs.map.mapObject

      map.addControl(this.drawnPois)

      const drawControl = new window.L.Control.Draw({
        position: 'topleft',
        draw: {
          /**
           * All available elements that can be used. For our use case
           * we only need polygon and circle. If you want to add any other,
           * just change these properties to true, and it will be auto added
           * to the draw control in the topleft corner of the map.
           */
          polygon: true,
          circle: true,
          polyline: false,
          rectangle: false,
          marker: true,
          circlemarker: false
        },
        edit: {
          /**
           * fetureGroup is required property. It will allow us to edit
           * any element on the map. Members of our feature group will be
           * circles and polygons that are coming from API and that we draw.
           */
          featureGroup: this.drawnPois,
          /**
           * Setting this property to true will allow users to remove any element
           * on the map, that is part of this.drawnItems object.
           */
          remove: hideControls ? false : true,
          edit: hideControls ? false : true
        }
      })

      /**
       * EditToolbar can be used to customize topleft controls.
       * For example we are hiding the option to Remove All Layers,
       * when user clicks delete action.
       */
      window.L.EditToolbar.Delete.include({
        removeAllLayers: false
      })

      /**
       * Adding our draw control to our map. Without .addControl call our map would not
       * be aware of it.
       */
      map.addControl(drawControl)

      /**
       * Setting up our draw events. Leaflet draw supports a lot of events. You can find
       * full list on next url: http://leaflet.github.io/Leaflet.draw/docs/leaflet-draw-latest.html
       * For us we only need CREATED, EDITED and DELETED events.
       */
      map.on(window.L.Draw.Event.CREATED, e => {
        this.onDrawCreated(e)
      })

      map.on(window.L.Draw.Event.EDITED, e => {
        this.onDrawEdited(e)
      })

      map.on(window.L.Draw.Event.EDITSTART, e => {
        this.readyToEditLocation = true
      })

      map.on(window.L.Draw.Event.EDITSTOP, e => {
        this.readyToEditLocation = false
      })

      map.on(window.L.Draw.Event.DELETED, e => {
        if (that.locationsForDelete.length) {
          that.locationsForDelete.forEach(i => {
            remove(`/locations/${i.id}`)
            store.dispatch('map/removeLocation', i)
          })
          that.locationMarkers = []
          that.locations.forEach(i => that.locationMarkers.push(i))
        }
        e.layers.eachLayer(layer => {
          remove(`/pois/${layer._id}`)
        })
      })

      map.on(window.L.Draw.Event.DELETESTART, e => {
        this.readyToDeleteLocation = true
      })
      map.on(window.L.Draw.Event.DELETESTOP, e => {
        var that = this
        this.readyToDeleteLocation = false
        this.locationMarkers = []
        this.locations.forEach(i => that.locationMarkers.push(i))
      })
    },
    onDrawCreated(e) {
      if (e.layerType == 'circle') {
        this.handleCircleOverlayCreated(e)
      }

      if (e.layerType == 'polygon') {
        this.handlePolygonOverlayCreated(e)
      }

      if (e.layerType == 'marker') {
        this.handleLocationPointCreated(e.layer._latlng)
      }
    },
    onDrawEdited(e) {
      /**
       * On edit event we are getting object with layers.
       * First we need to grab that first object key in order to
       * reach the whole layer object.
       */
      var layerKey = Object.keys(e.layers._layers)[0]
      var layer = e.layers._layers[layerKey]

      var data

      if (layer._type == 1) {
        data = {
          polygon: layer
        }
        data.eventType = 'POLYGON'
      }

      if (layer._type == 0) {
        data = {
          circle: layer
        }
        data.eventType = 'CIRCLE'
      }

      this.handleMapCrudComponentVisibility(data)
    },
    handleCircleOverlayCreated(circle) {
      circle.layer._id = ''
      circle.layer._poiName = ''
      circle.layer._poiTime = ''
      circle.layer._restrictionType = ''
      circle.layer._color = '#1CE'
      circle.layer._type = 0
      circle.layer._maximumSpeed = ''

      this.drawnPois.addLayer(circle.layer)

      var data = {
        circle: circle.layer
      }
      data.eventType = 'CIRCLE'
      this.handleMapCrudComponentVisibility(data)
    },
    handlePolygonOverlayCreated(polygon) {
      polygon.layer._id = ''
      polygon.layer._poiName = ''
      polygon.layer._poiTime = ''
      polygon.layer._restrictionType = ''
      polygon.layer._color = '#1CE'
      polygon.layer._type = 1
      polygon.layer._maximumSpeed = ''

      this.drawnPois.addLayer(polygon.layer)

      var data = {
        polygon: polygon.layer
      }
      data.eventType = 'POLYGON'
      this.handleMapCrudComponentVisibility(data)
    },
    handleMapCrudComponentVisibility(data) {
      this.mapCrudData = data

      //this.showMapCrud = true
      this.dialog.show = true
    },
    onCloseLocationDialogHandler() {
      this.locationDialog.show = false
    },
    onSubmitLocationDialogHandler() {
      this.locationDialog.submited = true
    },
    handleLocationPointCreated(loc) {
      let data = {
        name: '',
        longitude: loc.lng,
        latitude: loc.lat,
        edit: false
      }
      this.mapCrudLocationData = data
      this.locationDialog.show = true
    },
    moveMarker(marker, $event) {
      let data = {
        name: marker.name,
        longitude: $event.target._latlng.lng,
        latitude: $event.target._latlng.lat,
        edit: true,
        id: marker.id
      }
      this.mapCrudLocationData = data
      this.locationDialog.show = true
    },
    openPopup: function(event) {
      Vue.nextTick(() => {
        event.target.openPopup()
      })
    },
    closePopup: function(event) {
      Vue.nextTick(() => {
        event.target.closePopup()
      })
    },
    clickOnLocation(marker) {
      if (this.readyToDeleteLocation) {
        var locationIndex = this.locationMarkers.indexOf(marker)
        this.locationMarkers.splice(locationIndex, 1)
      }
      if (this.readyToEditLocation) {
        this.mapCrudLocationData = {
          id: marker.id,
          name: marker.name,
          longitude: marker.latLng.lng,
          latitude: marker.latLng.lat,
          edit: true
        }
        this.locationDialog.show = true
      }
    },
    handlePoiNameInTableEvent(poi) {
      this.$refs.map.mapObject.eachLayer(layer => {
        layer.closePopup()
        if (layer._id && layer._id == poi.id) {
          Vue.nextTick(() => {
            layer.openPopup()
          })
        }
      })
      var coordinates = []
      poi.coordinates.forEach(c =>
        coordinates.push({
          longitude: c.longitude,
          latitude: c.latitude
        })
      )
      this.zoomToRoute(coordinates)
    },
    handleEditPoiButtonEvent(data) {
      if (data.type == 0) {
        this.handleEditCirclePoiButtonEvent(data)
      } else if (data.type == 1) {
        this.handleEditPolygonPoiButtonEvent(data)
      }
    },
    handleEditCirclePoiButtonEvent(data) {
      let circle = {
        circle: {
          _id: data.id,
          _poiName: data.name,
          _poiTime: data.allowedStayMinutes,
          _color: data.color,
          _type: data.type,
          _restrictionType: data.restriction,
          _vehicleIds: data.vehicleIds,
          _mRadius: data.radius,
          _latlng: {
            lat: data.coordinates[0].latitude,
            lng: data.coordinates[0].longitude
          },
          _contacts: data.contacts,
          _hasParking: data.hasParking,
          _objectType: data.objectType,
          _unloadPlaceType: data.unloadPlaceType,
          _pointOfInterestType: data.pointOfInterestType,
          _objectCode: data.objectCode,
          _hasRamp: data.hasRamp,
          _hasForklift: data.hasForklift,
          _specialPermitRequired: data.specialPermitRequired,
          _posClientId: data.posClientId,
          _businessUnitId: data.businessUnitId,
          _maximumSpeed: data.maximumSpeed,
          _dwellTimeMin: data.dwellTimeMin
        },
        eventType: 'CIRCLE',
        dataFromEditButton: true
      }

      this.handleMapCrudComponentVisibility(circle)
    },
    handleEditPolygonPoiButtonEvent(data) {
      let coor = []
      data.coordinates.forEach(x => {
        coor.push({
          lat: x.latitude,
          lng: x.longitude
        })
      })
      let polygon = {
        polygon: {
          _id: data.id,
          _poiName: data.name,
          _poiTime: data.allowedStayMinutes,
          _color: data.color,
          _type: data.type,
          _restrictionType: data.restriction,
          _vehicleIds: data.vehicleIds,
          _mRadius: '',
          _latlngs: coor,
          _maximumSpeed: data.maximumSpeed
        },
        eventType: 'POLYGON',
        dataFromEditButton: true
      }

      this.handleMapCrudComponentVisibility(polygon)
    }
  }
}
</script>

<style src="leaflet/dist/leaflet.css">
</style>
<style src="leaflet-draw/dist/leaflet.draw.css">
</style>
<style src="../../../assets/icons.css">
</style>
<style >
.vue2leaflet-map {
  z-index: 1 !important;
}
</style>
<style scoped>
.rounded_card {
  border-radius: 2px;
}
</style>
